/** Figma / handoff display labels for city slugs on the home locations list. */
const HOME_LOCATION_CITY_LABEL_BY_SLUG: Readonly<Record<string, string>> = {
  phoenix: 'Phoenix',
  fresno: 'Fresno',
  'bay-area': 'Bay Area',
  'inland-empire': 'Inland Empire',
  'los-angeles': 'Los Angeles',
  'orange-county': 'Orange County',
  'san-diego': 'San Diego',
  denver: 'Denver',
  'washington-dc': 'Washington D.C.',
  jacksonville: 'Jacksonville',
  miami: 'Miami',
  orlando: 'Orlando',
  'tampa-bay': 'Tampa Bay',
  chicago: 'Chicago',
  baltimore: 'Baltimore',
  boston: 'Boston',
  detroit: 'Detroit',
  'new-jersey': 'New Jersey',
  'the-bronx': 'Bronx',
  brooklyn: 'Brooklyn',
  manhattan: 'Manhattan',
  'new-york': 'New York City',
  queens: 'Queens',
  toronto: 'Toronto',
  philadelphia: 'Philadelphia',
  pittsburgh: 'Pittsburgh',
  nashville: 'Nashville',
  austin: 'Austin',
  dallas: 'Dallas',
  houston: 'Houston',
  'san-antonio': 'San Antonio',
  alexandria: 'Alexandria',
  arlington: 'Arlington',
  seattle: 'Seattle',
};

export const getHomeLocationCityLabel = (
  slug: string,
  fallbackName: string,
): string => HOME_LOCATION_CITY_LABEL_BY_SLUG[slug] ?? fallbackName;
